module.exports = __webpack_public_path__ + "static/img/アセット 27@2x.bf2a6bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_history/アセット 27@2x.png
// module id = ETBt
// module chunks = 1